<template>
    <b-modal
    v-model="openSearchItemModal"
    title="Buscador de items"
    header-bg-variant="dark"
    header-text-variant="light"
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    >
    <b-form-group label="Código del item" label-for="item-reference" class="mb-3">
            <b-form-input
                id="item-reference"
                v-model="searchData.item_reference"
                placeholder="Ingrese el código del item"
                class="mb-3"
            />
    </b-form-group>

    <template v-slot:modal-footer>
        <b-button variant="danger" @click.prevent="$emit('close-modal')">
                Cancelar
        </b-button>
        <b-button variant="success" :disabled="searchData.item_reference === ''" @click.prevent="confirmSelection()">
                Buscar
        </b-button>
    </template>
    </b-modal>
</template>

<script>
export default {
    name: "ModalSearchItem",
    props: {
        openSearchItemModal: {
            type: Boolean,
            default: false
        },
        searchData: {
            type: Object
        }
    },
    methods: {
        confirmSelection() {
            this.$emit('confirm-search');
            this.$emit('close-modal');
        }
    }
};

</script>
